// in src/posts.js
import React from 'react';
import { useTheme, useMediaQuery, CardActions as MuiCardActions } from '@mui/material';
import Button from '@mui/material/Button';
import {
    Filter,
    DeleteButton,
    RefreshButton,
    DateField,
    RichTextField,
    SimpleShowLayout,
    Show,
    ShowButton,
    SimpleList,
    List,
    Datagrid,
    ReferenceField,
    TextField,
    useNotify,
    useRedirect,
    TextInput,
} from 'react-admin';
import { OnlyShowActionsDetail } from './FieldComponents/OnlyShowActions';
import Constants from './../shared/constants';

const ApqrFilter = (props) => (
    <Filter {...props}>
        <TextInput label="Buscar" source="issue" alwaysOn />
    </Filter>
);

const cardActionStyle = {
    zIndex: 2,
    display: 'inline-block',
    float: 'right',
};

export const ActionsListPQRS = ({ basePath, data }) => (
    <MuiCardActions style={cardActionStyle}>
        <RefreshButton />
        <Button
            variant="contained"
            color="primary"
            href={`${Constants.general.serverURL}/api/apqrs/csvexport/xmls`}
            target="_blank"
            download="PQRS.xlsx"
        >
            Exportar Excel
        </Button>
    </MuiCardActions>
);

export const ApqrsList = (props) => {
    const theme = useTheme();
    const isSmall = useMediaQuery(theme.breakpoints.down('sm'));

    return (
        <List
            {...props}
            title="Respuestas PQRS"
            actions={<ActionsListPQRS />}
            filters={<ApqrFilter />}
        >
            {isSmall ? (
                <SimpleList
                    primaryText={record => record.name}
                    tertiaryText={record => new Date(record.createdAt).toLocaleDateString()}
                />
            ) : (
                <Datagrid>
                    <ReferenceField label="Categoría" source="issue" reference="pqrs">
                        <TextField source="title" />
                    </ReferenceField>
                    <TextField source="name" label="Nombres" />
                    <TextField source="last_name" label="Apellidos" />
                    <TextField source="email" label="Email" />
                    <TextField source="telephone" label="Teléfono" />
                    <TextField source="comment" label="Comentario" />
                    <ShowButton />
                    <DeleteButton />
                </Datagrid>
            )}
        </List>
    );
};

export const ApqrsShow = (props) => (
    <Show title="PQRS Detalle" actions={<OnlyShowActionsDetail />} {...props}>
        <SimpleShowLayout>
            <ReferenceField label="Categoría" source="issue" reference="pqrs">
                <TextField source="title" />
            </ReferenceField>
            <TextField source="name" label="Nombres" />
            <TextField source="last_name" label="Apellidos" />
            <TextField source="document_type" label="Tipo de documento" />
            <TextField source="document" label="Número de identificación" />
            <TextField source="email" label="Email" />
            <TextField source="telephone" label="Teléfono" />
            <RichTextField source="comment" label="Comentario" />
            <DateField source="createdAt" label="Fecha de publicación" />
        </SimpleShowLayout>
    </Show>
);
